
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderPaymentGrid extends Serenity.EntityGrid<OrderPaymentRow, any> {
        protected getColumnsKey() { return OrderPaymentColumns.columnsKey; }
        protected getDialogType() { return OrderPaymentDialog; }
        protected getIdProperty() { return OrderPaymentRow.idProperty; }
        protected getInsertPermission() { return OrderPaymentRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderPaymentRow.localTextPrefix; }
        protected getService() { return OrderPaymentService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            this.editItem({ OrderId: this.OrderId });
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this.OrderId != null;
        }

        private _OrderId: number;

        get OrderId() {
            return this._OrderId;
        }

        set OrderId(value: number) {
            if (this._OrderId != value) {
                this._OrderId = value;
                this.setEquality(OrderPaymentRow.Fields.OrderId, value);
                this.refresh();
            }
        }
    }
}